module.exports = __webpack_public_path__ + "static/img/2014.e7792a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2014.png
// module id = qnWF
// module chunks = 1